module.exports = __webpack_public_path__ + "static/media/insta3.ace540c0.jpg";